import React, { useEffect, useRef, useState } from "react";
import { Box, Button, useTheme } from "@mui/material";
import { DataGrid, GridFilterPanel, useGridApiRef } from "@mui/x-data-grid";
import { useMaterialUIController } from "context";

const MDDataGrid = (props) => {
  const {
    sx,
    filterModel: externalFilterModel,
    onFilterModelChange,
    ...rest
  } = props;

  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const apiRef = useGridApiRef();
  const [initialized, setInitialized] = useState(false);

  const [draftModel, setDraftModel] = useState({ items: [] });

  const draftRef = useRef(draftModel);
  const isServer = typeof onFilterModelChange === "function";

  useEffect(() => {
    if (!initialized && externalFilterModel) {
      setDraftModel(externalFilterModel);
      draftRef.current = externalFilterModel;
      setInitialized(true);
    }
  }, [externalFilterModel, initialized]);

 
  const handleApply = () => {
    const latestModel = draftRef.current || { items: [] };

    const validFilters = latestModel.items.filter(
      (item) =>
        item.value !== undefined && item.value !== null && item.value !== "",
    );

    if (onFilterModelChange) {
      onFilterModelChange({
        ...latestModel,
        items: validFilters,
      });
    }

    apiRef.current.hideFilterPanel();
  };

  const handleReset = () => {
    const emptyModel = { items: [] };
    draftRef.current = emptyModel;

    if (onFilterModelChange) {
      onFilterModelChange(emptyModel);
    }

    apiRef.current.setFilterModel(emptyModel);
    apiRef.current.hideFilterPanel();
  };
  return (
    <>
      <DataGrid
        {...rest}
        filterMode={isServer ? "server" : "client"}
        apiRef={apiRef}
            onFilterModelChange={
          isServer
            ? (model) => {
                draftRef.current = model;
              }
            : undefined
        }
        slots={{
          filterPanel: isServer
            ? (panelProps) => (
                <Box>
                  {/* ✅ let MUI control input properly */}
                  <GridFilterPanel {...panelProps} />

                  {/* ✅ Apply / Reset */}
                  <Box
                    sx={{
                      p: 1.5,
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                      borderTop: "1px solid",
                      borderColor: darkMode
                        ? "rgba(255,255,255,0.12)"
                        : "rgba(0,0,0,0.12)",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={handleReset}
                      sx={{ color: darkMode ? "#fff" : "inherit" }}
                    >
                      Reset
                    </Button>

                    <Button
                      size="small"
                      variant="contained"
                      color="info"
                      onClick={handleApply}
                    >
                      Apply
                    </Button>
                  </Box>
                </Box>
              )
            : undefined,
        }}
        slotProps={{
          panel: {
            sx: {
              [theme.breakpoints.down("sm")]: {
                "& .MuiDataGrid-paper": {
                  margin: 1,
                  "& .MuiDataGrid-filterForm": {
                    flexWrap: "wrap",
                    gap: "8px",
                    "& .MuiDataGrid-filterFormDeleteIcon": {
                      justifyContent: "center",
                    },
                    "& .MuiDataGrid-filterFormColumnInput": { width: "85%" },
                    "& .MuiDataGrid-filterFormOperatorInput,& .MuiDataGrid-filterFormValueInput":
                      {
                        width: "100%",
                      },
                  },
                },
              },
            },
          },
        }}
        sx={{
          border: 0.5,
          fontSize: "12px",
          borderColor: `${theme.palette.grey[200]}`,
          boxShadow: "none",
          color: darkMode ? "#ffffff" : "#1c1c1c",
          "& .MuiDataGrid-main": {
            overflow: "hidden",
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowY: "auto !important",
            maxHeight: "calc(100vh - 150px)",
          },
          "& .MuiDataGrid-columnHeader,.MuiDataGrid-cell": {
            ":focus": {
              outline: "none",
            },
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
          },
          "& .MuiDataGrid-columnHeader--sorted:,& .MuiDataGrid-columnHeader--filtered,& .MuiDataGrid-columnHeader--sortable":
            {
              ":focus-within": { outline: "none" },
            },
          "& .MuiDataGrid-sortIcon": {
            color: darkMode ? "#ffffff" : "#1c1c1c",
          },
          "& .MuiTypography-root": {
            color: darkMode ? "#ffffff" : "#000000",
            fontWeight: "400",
          },
          "& .MuiDataGrid-menuIconButton": {
            color: darkMode ? "#ffffff" : "#1c1c1c",
          },
          "& .MuiTablePagination-selectLabel": {
            color: darkMode ? "#ffffff" : "#1c1c1c",
          },
          "& .MuiTablePagination-input": {
            color: darkMode ? "#ffffff" : "#1c1c1c",
          },
          "& .MuiTablePagination-displayedRows": {
            color: darkMode ? "#ffffff" : "#1c1c1c",
          },
          "& .MuiSvgIcon-root": {
            color: darkMode ? "#ffffff" : "#1c1c1c",
          },
          "& .MuiIcon-root": {
            color: darkMode ? "#ffffff" : "#1c1c1c",
          },
          ...sx,
        }}
      />
    </>
  );
};

MDDataGrid.propTypes = {};

export default MDDataGrid;
